import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-client-demographics-report',
  imports: [ReportRunnerComponent],
  templateUrl: './client-demographics-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientDemographicsReportComponent {}
